export default "__VITE_ASSET__B74NHV8h__"